import React, { Component } from 'react';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';

class EirNotification extends Component {
  constructor(props) {
    super(props);
    this.state = { modal: false };
  }

  handleToggle = (e) => {
    e.preventDefault();

    if (this.props.description && this.props.imagePath) {
      this.setState({
        modal: !this.state.modal
      });
    }
  };

  render() {
    return (
      <React.Fragment>
        {this.state.modal && (

          <Modal centered isOpen={this.state.modal} toggle={this.handleToggle} className="eir-offer-modal align-items-center justify-content-center" >
            
            <ModalBody>
              <div className="eir-offer-modal-content">
                
                <ModalHeader toggle={this.handleToggle} />

                  <a href={this.props.url} target="_blank" className="eir-offer-modal-body d-flex flex-column align-items-center justify-content-start">
                  
                    <img className="eir-h-50" src={this.props.imagePath} alt={this.props.imageDescription} />
                    <h5 className="eir-offer-modal-title mt-2 w-50 text-center text-uppercase text-danger">{this.props.title}</h5>
                    <p className="eir-offer-modal-description w-75 text-center text-base-gray">{this.props.description}</p>
                    
                  </a>

              </div>

            </ModalBody>

          </Modal>
        )}

        <div onClick={this.handleToggle} className={ 'eir-notification-cta d-flex flex-column align-items-center justify-content-center bg-secondary p-1 p-sm-2 ' + this.props.className }>
          
          {this.props.title && (
            <h5 className="eir-notification-cta-title text-white m-0 text-uppercase align-self-stretch">{this.props.title}</h5>
          )}

          {this.props.shortDescription && (
            <p className="eir-notification-cta-description text-white m-0 align-self-stretch">{this.props.shortDescription}</p>
          )}

        </div>
      </React.Fragment>
    );
  }
}

export default EirNotification;
